import {erIkkeNil, erNil} from "./nilsjekk";
import {nil} from "../typer/nullish";
import {erStreng, erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {erIkkeTomListe} from "felles-ng2/støttefunksjoner/lister";
import {isDevMode} from "@angular/core";

type Melding = string | (() => string);

/** Kaster exception dersom angitt verdi er nil */
export function verifiserErIkkeNil<T>(verdi: T | nil, melding: Melding = ''): T {
    if (erIkkeNil(verdi)) return verdi;
    throw new Error(feilmelding(`forventet ikke-nil verdi, var '${verdi}'`, melding));
}

/** Kaster exception dersom angitt verdi ikke er nil */
export function verifiserErNil(verdi: any, melding: Melding = ''): void {
    if (erNil(verdi)) return;
    throw new Error(feilmelding(`forventet nil verdi, var '${verdi}'`, melding));
}

/** Kaster exception dersom angitt verdi er nil, men kun dersom i dev-mode */
export function verifiserErIkkeNilVedDevMode<T>(verdi: T | nil, melding: Melding = ''): T {
    return exceptionKunIDevMode(verdi, () => verifiserErIkkeNil(verdi, melding))!;
}

/** Kaster exception dersom angitt verdi er nil eller tom liste */
export function verifiserErIkkeTomListe<T>(verdi: T[] | nil, melding: Melding = ''): T[] {
    if (erIkkeTomListe(verdi)) return verdi;
    throw new Error(feilmelding(`forventet ikke-tom liste, var '${verdi}'`, melding));
}

/** Kaster exception dersom angitt verdi IKKE er false */
export function verifiserErUsann(verdi: boolean, melding: Melding = ''): boolean {
    if (verdi === false) return verdi;
    throw new Error(feilmelding(`forventet false, var '${verdi}'`, melding));
}

/** Kaster exception dersom angitt verdi IKKE er true */
export function verifiserErSann(verdi: boolean, melding: Melding = ''): boolean {
    if (verdi === true) return verdi;
    throw new Error(feilmelding(`forventet true, var '${verdi}'`, melding));
}

/** Kaster exception dersom angitt verdi IKKE er sann, men kun dersom i dev-mode */
export function verifiserErSannVedDevMode(verdi: boolean, melding: Melding = ''): boolean {
    return exceptionKunIDevMode(verdi, () => verifiserErSann(verdi, melding))!;
}

/** Kaster exception dersom angitt liste ikke inneholder angitt verdi */
export function verifiserAtListeInneholder<T>(liste: T[], verdi: T, melding: Melding = ''): T {
    if (liste.includes(verdi)) return verdi;
    throw new Error(feilmelding(`forventet at liste ${liste}, inneholder '${verdi}'`, melding));
}

/** Kaster exception dersom angitt liste ikke inneholder angitt verdi */
export function verifiserAtErInneholdIListe<T>(verdi: T, liste: T[], melding: Melding = ''): T[] {
    verifiserAtListeInneholder(liste, verdi, melding);
    return liste;
}


function exceptionKunIDevMode<T>(verdi: T, verifisering: () => T) {
    try {
        return verifisering()
    } catch (e: any) {
        if (isDevMode()) throw e;
        console.error(e.message)
        return verdi;
    }
}

function feilmelding(ledetekst: string, melding: Melding): string {
    const feilmelding = erStreng(melding) ? melding : melding();
    if (erTomEllerNil(feilmelding)) return ledetekst;
    return `${ledetekst}, ${feilmelding}`;
}
